import { NewBestPromosController } from "./new-best-promos.controller";

const newBestPromosBlockComponent = {
	bindings: {},
	template: require("./external-new-best-promos.html"),
	controller: NewBestPromosController,
	controllerAs: "nbpc",
};

export default newBestPromosBlockComponent;